import { render, staticRenderFns } from "./RfvPeriods.vue?vue&type=template&id=5eba3d40&scoped=true"
import script from "./RfvPeriods.vue?vue&type=script&lang=js"
export * from "./RfvPeriods.vue?vue&type=script&lang=js"
import style0 from "./RfvPeriods.vue?vue&type=style&index=0&id=5eba3d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eba3d40",
  null
  
)

export default component.exports